import { render, staticRenderFns } from "./NotificationItem.vue?vue&type=template&id=b6552524&scoped=true&"
import script from "./NotificationItem.vue?vue&type=script&lang=js&"
export * from "./NotificationItem.vue?vue&type=script&lang=js&"
import style0 from "./NotificationItem.vue?vue&type=style&index=0&id=b6552524&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6552524",
  null
  
)

export default component.exports